import Motlet from './Motlet.vue';
// Added.by.KWShin.2024.01.12.
import MotletNeo from './MotletNeo.vue';
// BEGIN::Modified.by.KWShin.2024.01.12.
// export default Motlet;
export { Motlet, MotletNeo };
// FINISH::Modified.by.KWShin.2024.01.12.
